import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Cookie, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('foresthub-cookie-consent');
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('foresthub-cookie-consent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-stone-200 shadow-lg animate-in slide-in-from-bottom duration-300"
      data-testid="cookie-consent"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-10 h-10 rounded-xl bg-[#E8F5E9] flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-[#1E5F3A]" />
          </div>
          <div>
            <h3 className="font-semibold text-stone-900 text-sm mb-1">{t('cookie.title')}</h3>
            <p className="text-sm text-stone-600">{t('cookie.description')}</p>
          </div>
        </div>
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <a 
            href="/datenschutz" 
            className="text-sm text-[#1E5F3A] hover:underline whitespace-nowrap"
          >
            {t('cookie.learnMore')}
          </a>
          <Button 
            onClick={acceptCookies}
            className="bg-[#1E5F3A] hover:bg-[#174A2D] text-white h-9 px-5 rounded-lg text-sm flex-1 sm:flex-none"
            data-testid="cookie-accept"
          >
            {t('cookie.accept')}
          </Button>
        </div>
      </div>
    </div>
  );
};
